import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalized,
  type RouteLocationNormalizedLoaded,
} from 'vue-router'
import { allRoutes } from '@/router/routes'
import { useAuthStore } from '@/requests/Auth'

const router = createRouter({
  history: createWebHistory('/'),
  routes: allRoutes,

  scrollBehavior(_to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, savedPosition: any) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { left: 0, top: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo) => {
  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

  // If auth isn't required for the route, just continue.
  if (!authRequired) return true

  const authStore = useAuthStore()
  // If auth is required and the user is logged in...
  if (authStore.isAuthorized) {
    return true
  }

  // If auth is required and the user is NOT currently logged in,
  // redirect to login.
  // Pass the original route to the login component.
  return {
    name: 'login',
    query: { redirectFrom: routeTo.fullPath },
  }
})

export default router
